<div class="user-card" [@dataChange]="dataState" (@dataChange.done)="dataState = DataState.DONE">
  <button *ngIf="canFlipCard" (click)="toggleCardView()" mat-icon-button [matTooltip]="getToggleTooltip()" matTooltipPosition="above" class="card-badge-flip">
    <span class="icon-flip"></span>
  </button>
  <div class="card-type" [ngClass]="getCardTypeClass(cardType)">
    <span [ngClass]="cardIcon"></span>
    {{ cardLabel }}
  </div>
  <div class="card-content">
    <div class="user-infos">
      <img class="user-avatar" id="user-avatar" [src]="photo" alt="avatar">

      <div class="user-name-wrap">
        <span class="user-name">{{ firstName }} {{ lastName }}</span>
      </div>
      <span class="user-organisation">{{ orgName }}</span>
      <span *ngIf="displayExpDate" class="user-card-expirationDate" [ngClass]="status === CardStatus.PROCESSING ? 'user-card-expirationDate-processing' : ''">
        {{ expDateString }}
      </span>
    </div>

    <div *ngIf="cardView === CardView.DEFAULT">
      <div class="user-nocard" *ngIf="!status && !canFlipCard">
        <div class="warning-icon">
          <span class="icon icon-warning"></span>
        </div>
        {{ 'pages.user-cards.my-card.no-card-warning' | translate }}
        <article class="button-message article-mb quill-content-wrapper ql-editor"
          [innerHTML]="instructionsGeneralIntroduction | safeHtml">
        </article>
        <!-- TODO: Currently not supported for family member -->
         <!--<div class="button-wrapper">
          <button class="bciti-button" 
            [disabled]="subscribeLoading"
            [ngClass]="subscribeLoading ? 'bciti-button--disabled' : 'bciti-button--blue'"
            (click)="subscribeToCard()">
            <div *ngIf="!subscribeLoading">{{ 'pages.user-cards.common.button.familySubscribe' | translate }}</div>
            <div class="loading-spinner" *ngIf="subscribeLoading">
              <mat-progress-spinner
                mode="indeterminate"
                diameter="20">
              </mat-progress-spinner>
            </div>
          </button>
          <article class="button-message article-mb quill-content-wrapper ql-editor" 
            [innerHTML]="subscribeTooltipButton | safeHtml">
          </article>
        </div>
        <div *ngIf="linkable" class="button-wrapper">
          <button class="bciti-button" 
            [disabled]="subscribeLoading" 
            [ngClass]="subscribeLoading ? 'bciti-button--disabled' : 'bciti-button--blue'" 
            (click)="linkCard()">
            {{ 'pages.user-cards.common.button.familyLink' | translate }}
          </button>
          <article class="button-message article-mb quill-content-wrapper ql-editor"
            [innerHTML]="linkTooltipButton | safeHtml">
          </article>
        </div>-->
      </div>
      <div class="user-card-details" *ngIf="!!card">

        <!--<div class="user-card-renewal-alert"
          *ngIf="(status === CardStatus.ACTIVE && showExpireSoonMessage && !card.renewal?.number && legacyCardShow) || (!isLegacyCard && status === CardStatus.EXPIRED && !card.renewal?.number && legacyCardShow)">
          <span class="renewal-message" *ngIf="showExpireSoonMessage && !showExpireMessage">
            {{ 'pages.user-cards.my-card.renewal-alert' | translate: {renewalDelay: cardConfig.renewalDelay} }}
          </span>
          <span class="renewal-message" *ngIf="showExpireSoonMessage && showExpireMessage">
            {{ 'pages.user-cards.my-card.expired-alert' | translate: {renewalDelay: cardConfig.renewalDelay} }}
          </span>
          <button class="bciti-button bciti-button--orange" (click)="renewCard()">
            {{ 'pages.user-cards.common.button.renew' | translate }}
          </button>
        </div>
        <div class="user-card-renewal-alert"
            *ngIf="(status === CardStatus.EXPIRED && card.renewal?.number)">
            <span class="renewal-message">
                {{ 'pages.user-cards.common.actionType.RENEWAL' | translate }}
            </span>
        </div> -->

        <span class="user-organisation-logo">
          <img [src]="orgLogo" alt="">
        </span>
        <!-- TODO: Revisit implementation. It's been disabled in favor of the Flip Card subscription feature. -->
        <!-- <div class="subscriptions-empty-wrap user-nocard" *ngIf="isLegacyCard && !legacyCardShow">
            <p [innerHTML]="'pages.user-cards.my-card.legacy-no-subscriptions' | translate"></p>
            <div class="button-wrapper">

                <button class="bciti-button bciti-button--blue" routerLink="/subscriptions">
                    {{ 'pages.user-cards.my-card.add-subscriptions' | translate }}
                </button>
            </div>
        </div> -->
        <div class="user-card-barcode" *ngIf="status === CardStatus.ACTIVE && !_loading && hasFamilySubscription()">
          <div *ngIf="cardConfig.barcode === BardCodeType.QRCODE && showCardInfo">
            <ngx-qrcode 
              id="qrcode" 
              [elementType]="qrcodeOpt.elementType"
              [errorCorrectionLevel]="qrcodeOpt.correctionLevel" 
              [value]="qrCodeForImage"
            ></ngx-qrcode>
          </div>
          <div *ngIf="cardConfig.barcode === BardCodeType.BARCODE && showCardInfo">
            <ngx-barcode6 
              bc-format="CODE39" 
              bc-width=1 
              [bc-value]="code" 
              [bc-display-value]="false"
            ></ngx-barcode6>
          </div>
          <img class="display-none" id='barcode'>
          <span *ngIf="showCardInfo">{{ code }}</span>
          <p class="constraint-required-subscriptions" *ngIf="requiredSubscription">{{requiredSubscription}}</p>
          <div class="card-subtype" *ngIf="subTypeName" [ngStyle]="{'background-color': subTypeColor}">
            {{subTypeName}}
          </div>
          <div class="user-card-syst-ext" *ngIf="cardConfig?.linkSystExt">
            
          </div>
          <div *ngIf="status === CardStatus.ACTIVE && showCardInfo" class="print-btn">
            <button [disabled]="cardPrintLoading" mat-icon-button class="card-badge" (click)="printCard()"
              [matTooltip]="getPrintTooltip()">
              <span *ngIf="!cardPrintLoading" class="no-margin icon-print-text"></span>
              <span class="no-margin" *ngIf="cardPrintLoading">
                <mat-progress-spinner mode="indeterminate" diameter="20">
                </mat-progress-spinner>
              </span>
            </button>
          </div>
        </div>        
      </div>
    </div>

    <div class="subscriptions-wrap" *ngIf="cardView === CardView.SUBSCRIPTIONS">
      <h4 *ngIf="subscriptions.length">{{ 'pages.user-cards.my-card.subscriptions' | translate }}</h4>
      <div class="subscription" *ngFor="let sub of subscriptions">
        <div class="icon">
          <span [ngClass]="sub.icon"></span>
        </div>
        <div class="info">
          <p class="name">{{ sub.name }}</p>
          <p class="code">{{ sub.code }}</p>
        </div>
        <div class="expiration">
          Exp.<br />{{ sub.endDate | shortDate }}
        </div>
      </div>
      <div class="subscriptions-empty-wrap" *ngIf="!subscriptions.length && canShowSubscriptions">
        <p [innerHTML]="'pages.user-cards.my-card.no-subscriptions' | translate"></p>
        <button class="bciti-inline-button" routerLink="/subscriptions">
          {{ 'pages.user-cards.my-card.subscriptions' | translate }} <span class="icon-search"></span>
        </button>
      </div>
      <div *ngIf="status === CardStatus.ACTIVE && showCardInfo" class="print-btn">
        <button [disabled]="cardPrintLoading" mat-icon-button class="card-badge" (click)="printCard()"
          [matTooltip]="getPrintTooltip()">
          <span *ngIf="!cardPrintLoading" class="no-margin icon-print-text"></span>
          <span class="no-margin" *ngIf="cardPrintLoading">
            <mat-progress-spinner mode="indeterminate" diameter="20">
            </mat-progress-spinner>
          </span>
        </button>
        <!-- This is required in order to be able to print card. The print logic relies on this component  -->
        <div class="hidden" *ngIf="cardConfig.barcode === BardCodeType.QRCODE && showCardInfo">
          <ngx-qrcode
            id="qrcode" 
            [elementType]="qrcodeOpt.elementType"
            [errorCorrectionLevel]="qrcodeOpt.correctionLevel" 
            [value]="qrCodeForImage"
          ></ngx-qrcode>
        </div>
        <div class="hidden" *ngIf="cardConfig.barcode === BardCodeType.BARCODE && showCardInfo">
          <ngx-barcode6 
            bc-format="CODE39" 
            bc-width=1 
            [bc-value]="code" 
            [bc-display-value]="false"
          ></ngx-barcode6>
        </div>
        <img class="hidden" id='barcode'>
      </div>
    </div>
  </div>
</div>